import { RegulationComponentsCommon } from "../../regulation-components-common";
import { USResponsibleGamingButtonsComponent } from "../../../../components/responsible-gambling/responsible-gaming-buttons/regulations/us/us.responsible-gaming-buttons.component";
import { TimeSpan } from "@sparkware/app-utils";
import { LastLoginSessionTimerSwitcherComponent } from "../../../../components/clock-and-last-login-box/last-login-session-timer-switcher/last-login-session-timer-switcher.component";

export class NewJerseyRegulationComponents extends RegulationComponentsCommon {
    renderHeaderRegulationIcons() {
        return (
            <USResponsibleGamingButtonsComponent />
        );
    }

    renderLastLoginComponent() {
        return (<LastLoginSessionTimerSwitcherComponent
            showLastLoginForever={true}
            switchToSessionTimerInterval={TimeSpan.fromSeconds(10)}
        />)
    }
}